import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './components/homepage';
import AddAddress from './components/AddressForm';
import FetchAddress from './components/FetchAddress';
import LoginPage from './components/LoginPage';
import SignupPage from './components/SignupPage';
import ForgotPasswordPage from './components/ForgotPasswordPage'; 
import PasswordResetPage from './components/PasswordResetPage';
import LandingPage from './components/LandingPage';  
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

const isAuthenticated = () => {
  return localStorage.getItem('jwtToken') !== null;  // Check if JWT token exists
};

const logout = () => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('userId');
  localStorage.removeItem('userName');
  window.location.href = '/';
};

const App = () => {
  useEffect(() => {
    // Set the title dynamically based on the current route
    const routeTitle = window.location.pathname === '/login' ? 'Login - AddressKeeper' :
      window.location.pathname === '/forgot-password' ? 'Forgot Password - AddressKeeper' :
      window.location.pathname === '/auth/signup' ? 'Signup - AddressKeeper' :
      window.location.pathname === '/add-address' ? 'Add Address - AddressKeeper' :
      window.location.pathname === '/fetch-address' ? 'Fetch Address - AddressKeeper' :
      window.location.pathname === '/auth/reset-password' ? 'Reset Password - AddressKeeper' :
      window.location.pathname === '/privacy-policy' ? 'Privacy Policy - AddressKeeper' :
      'AddressKeeper'; // Default title

    document.title = routeTitle;
  }, []);

  return (
    <Router>
      <div className="app-container">
        {/* Wrapper for the logout button */}
        <div className="logout-container">
          <button onClick={logout} className="btn btn-danger logout-btn">
            Logout
          </button>
        </div>

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={isAuthenticated() ? <HomePage className="home-page" /> : <Navigate to="/login" />} />
          <Route path="/login" element={<LoginPage className="login-page" />} />
          <Route path="/auth/signup" element={<SignupPage className="signup-page" />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage className="forgot-password-page" />} />
          {/* Reset Password Page Route (Dynamic Route for token) */}
          <Route path="/auth/reset-password/:token" element={<PasswordResetPage className="password-reset-page" />} />
          
          {/* Protected Routes */}
          <Route path="/add-address" element={isAuthenticated() ? <AddAddress className="add-address-page" /> : <Navigate to="/login" />} />
          <Route path="/fetch-address" element={isAuthenticated() ? <FetchAddress className="fetch-address-page" /> : <Navigate to="/login" />} />

          {/* Privacy Policy Route */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Add Privacy Policy Route */}

        </Routes>
      </div>
    </Router>
  );
};

export default App;
